import bfTabs from './bf-tabs.vue';
bfTabs.install = Vue => Vue.component(bfTabs.name,bfTabs);
export default bfTabs;



// WEBPACK FOOTER //
// ./src/packages/tabs/bf-tabs/index.js